import { LocationValidationRules } from './validation';

export const ValidationRules: LocationValidationRules = {
  Default: {
    featureFlags: {
      showInspectionRedirectLink: false,
    },
    pages: {
      createUli: {
        uliInformation: {
          loadNumber: { required: true, shouldBeUnique: true },
          pickupPartyAddress: { required: true, disabled: false },
          deliveryPartyAddress: { required: true, disabled: false },
          dangerousGoods: { required: false },
          scheduledRegistrationTime: { required: true },
          type: { required: true },
          numberOfHandlingUnits: { required: true, patternKey: 'onlyNumber' },
          documentNumbers: { required: false },
          weightGross: { required: true, patternKey: 'onlyNumber' },
          loadingMeters: { required: false, patternKey: 'decimalNumber' },
        },

        multiStopInformation: {
          loadNumber: { required: true, shouldBeUnique: true },
          transportOrders: {
            isArray: true,
            elementRules: {
              activityType: { required: true },
              transportOrderNumber: { required: true },
              pickupPartyAddress: { required: true, disabled: false },
              deliveryPartyAddress: { required: true, disabled: false },
              dangerousGoods: { required: false },
              scheduledDepartureTime: { required: true },
              scheduledArrivalTime: { required: true },
              numberOfHandlingUnits: { required: true, patternKey: 'onlyNumber' },
              documentNumbers: { required: false },
              weightGross: { required: true, patternKey: 'onlyNumber' },
              loadingMeters: { required: false, patternKey: 'decimalNumber' },
            },
          },
        },

        truckInformation: {
          dangerousGoods: { required: false },
          loadingTypes: { required: true },
          truckPlateId: { required: false, patternKey: 'vehicleId' },
          truckPlateIdCountryOfOrigin: { required: false },
          trailerPlateId: { required: false, patternKey: 'vehicleId' },
          trailerPlateIdCountryOfOrigin: { required: false },
          truckSize: { required: true },
          emissionStage: { required: false },
        },

        contactData: {
          carrierEmail: { required: false, patternKey: 'email' },
          carrierName: { required: true },
          carrierExtId: { required: true },
          carrierPhone: { required: false, patternKey: 'phoneGeneric' },
          rbTransportPlannerEmail: { required: false, patternKey: 'email' },
          rbTransportPlannerPhone: { required: false, patternKey: 'phoneGeneric' },
        },

        driverInformation: {
          firstName: { required: false, patternKey: 'humanName' },
          lastName: { required: false, patternKey: 'humanName' },
          loanerPhoneId: { required: false, patternKey: 'phoneGeneric' },
          permitNumber: { required: false },
          permitType: { required: false },
          phoneNumber: { required: false, patternKey: 'phoneGeneric' },
          frequentDriverId: { required: false, patternKey: 'onlyNumber' },
        },
      },

      registerUli: {
        truckInformation: {
          loadingTypes: { required: true },
          truckPlateId: { required: true, patternKey: 'vehicleId' },
          trailerPlateId: { required: true, patternKey: 'vehicleId' },
          truckPlateIdCountryOfOrigin: { required: true },
          trailerPlateIdCountryOfOrigin: { required: true },
          emissionStage: { required: false },
        },

        driverInformation: {
          firstName: { required: true },
          lastName: { required: true },
          phoneNumber: { required: true, patternKey: 'phoneGeneric' },
          permitNumber: { required: false },
          permitType: { required: false },
          frequentDriverId: { required: false },
          loanerPhoneId: { required: false },
          parkingSpaceId: { required: false },
          remainingDrivingTime: { required: false },
          nextBreakLength: { required: false },
        },
      },

      createHub: {
        hubInfo: {
          name: { required: true },
          country: { required: true },
          timezone: { required: true },
          ssccId: { required: true, patternKey: 'ssccId' },
          nextActionApp: { required: true },
          coordinatorEmail: { required: false, patternKey: 'email' },
          coordinatorPhone: { required: false, patternKey: 'phoneGeneric' },
          mainGatePhone: { required: true, patternKey: 'phoneGeneric' },
          registrationDuration: { required: false, patternKey: 'onlyNumber' },
          securityOverdueMin: { required: false, patternKey: 'onlyNumber' },
          automaticUliCleaningDaysBefore: { required: false, patternKey: 'onlyNumber' },
          automaticUliCleaningDaysAfter: { required: false, patternKey: 'onlyNumber' },
          automaticUliCleaningHours: { required: false, patternKey: 'onlyNumber' },
        },
      },

      createCompartment: {
        generalInfo: {
          name: { required: true },
          ssccId: { required: true, patternKey: 'compartmentSsccId' },
          compartmentAddresses: { required: true },
          yardTime1: { required: true, patternKey: 'onlyNumber' },
          yardTime2: { required: true, patternKey: 'onlyNumber' },
          onTime: { required: true, patternKey: 'onlyNumber' },
        },
      },
    },
  },

  DE: {
    featureFlags: {
      showInspectionRedirectLink: true,
    },
    pages: {
      createUli: {
        uliInformation: {
          loadNumber: { required: true, shouldBeUnique: true },
          pickupPartyAddress: { required: true, disabled: false },
          deliveryPartyAddress: { required: true, disabled: false },
          dangerousGoods: { required: false },
          scheduledRegistrationTime: { required: true },
          type: { required: true },
          numberOfHandlingUnits: { required: true, patternKey: 'onlyNumber' },
          documentNumbers: { required: false },
          weightGross: { required: true, patternKey: 'onlyNumber' },
          loadingMeters: { required: false, patternKey: 'decimalNumber' },
        },
        multiStopInformation: {
          loadNumber: { required: true, shouldBeUnique: true },
          transportOrders: {
            isArray: true,
            elementRules: {
              activityType: { required: true },
              transportOrderNumber: { required: true },
              pickupPartyAddress: { required: true, disabled: false },
              deliveryPartyAddress: { required: true, disabled: false },
              dangerousGoods: { required: false },
              scheduledDepartureTime: { required: true },
              scheduledArrivalTime: { required: true },
              numberOfHandlingUnits: { required: true, patternKey: 'onlyNumber' },
              documentNumbers: { required: false },
              weightGross: { required: true, patternKey: 'onlyNumber' },
              loadingMeters: { required: false, patternKey: 'decimalNumber' },
            },
          },
        },
        truckInformation: {
          dangerousGoods: { required: false },
          loadingTypes: { required: true },
          truckPlateId: { required: false, patternKey: 'vehicleId' },
          truckPlateIdCountryOfOrigin: { required: false },
          trailerPlateId: { required: false, patternKey: 'vehicleId' },
          trailerPlateIdCountryOfOrigin: { required: false },
          truckSize: { required: true },
          emissionStage: { required: false },
        },
        contactData: {
          carrierEmail: { required: false, patternKey: 'email' },
          carrierName: { required: true },
          carrierExtId: { required: true },
          carrierPhone: { required: false, patternKey: 'phoneGeneric' },
          rbTransportPlannerEmail: { required: false, patternKey: 'email' },
          rbTransportPlannerPhone: { required: false, patternKey: 'phoneGeneric' },
        },
        driverInformation: {
          firstName: { required: false, patternKey: 'humanName' },
          lastName: { required: false, patternKey: 'humanName' },
          loanerPhoneId: { required: false, patternKey: 'phoneGeneric' },
          permitNumber: { required: false },
          permitType: { required: false },
          phoneNumber: { required: false, patternKey: 'phoneGeneric' },
          frequentDriverId: { required: false, patternKey: 'onlyNumber' },
        },
      },
      registerUli: {
        truckInformation: {
          loadingTypes: { required: true },
          truckPlateId: { required: true, patternKey: 'vehicleId' },
          trailerPlateId: { required: true, patternKey: 'vehicleId' },
          truckPlateIdCountryOfOrigin: { required: true },
          trailerPlateIdCountryOfOrigin: { required: true },
          emissionStage: { required: false },
        },
        driverInformation: {
          firstName: { required: true },
          lastName: { required: true },
          phoneNumber: { required: true, patternKey: 'phoneGeneric' },
          permitNumber: { required: false },
          permitType: { required: false },
          frequentDriverId: { required: false },
          loanerPhoneId: { required: false },
          parkingSpaceId: { required: false },
          remainingDrivingTime: { required: false },
          nextBreakLength: { required: false },
        },
      },

      createHub: {
        hubInfo: {
          name: { required: true },
          country: { required: true },
          timezone: { required: true },
          ssccId: { required: true, patternKey: 'ssccId' },
          nextActionApp: { required: true },
          coordinatorEmail: { required: false, patternKey: 'email' },
          coordinatorPhone: { required: false, patternKey: 'phoneGeneric' },
          mainGatePhone: { required: true, patternKey: 'phoneGeneric' },
          registrationDuration: { required: false, patternKey: 'onlyNumber' },
          securityOverdueMin: { required: false, patternKey: 'onlyNumber' },
          automaticUliCleaningDaysBefore: { required: false, patternKey: 'onlyNumber' },
          automaticUliCleaningDaysAfter: { required: false, patternKey: 'onlyNumber' },
          automaticUliCleaningHours: { required: false, patternKey: 'onlyNumber' },
        },
      },

      createCompartment: {
        generalInfo: {
          name: { required: true },
          ssccId: { required: true, patternKey: 'compartmentSsccId' },
          compartmentAddresses: { required: true },
          yardTime1: { required: true, patternKey: 'onlyNumber' },
          yardTime2: { required: true, patternKey: 'onlyNumber' },
          onTime: { required: true, patternKey: 'onlyNumber' },
        },
      },
    },
  },

  HU: {
    featureFlags: {
      showInspectionRedirectLink: false,
    },
    pages: {
      createUli: {
        uliInformation: {
          loadNumber: { required: true, shouldBeUnique: true },
          pickupPartyAddress: { required: true, disabled: false },
          deliveryPartyAddress: { required: true, disabled: false },
          dangerousGoods: { required: false },
          scheduledRegistrationTime: { required: true },
          type: { required: true },
          numberOfHandlingUnits: { required: true, patternKey: 'onlyNumber' },
          documentNumbers: { required: false },
          weightGross: { required: true, patternKey: 'onlyNumber' },
          loadingMeters: { required: false, patternKey: 'decimalNumber' },
        },

        multiStopInformation: {
          loadNumber: { required: true, shouldBeUnique: true },
          transportOrders: {
            isArray: true,
            elementRules: {
              activityType: { required: true },
              transportOrderNumber: { required: true },
              pickupPartyAddress: { required: true, disabled: false },
              deliveryPartyAddress: { required: true, disabled: false },
              dangerousGoods: { required: false },
              scheduledDepartureTime: { required: true },
              scheduledArrivalTime: { required: true },
              numberOfHandlingUnits: { required: true, patternKey: 'onlyNumber' },
              documentNumbers: { required: false },
              weightGross: { required: true, patternKey: 'onlyNumber' },
              loadingMeters: { required: false, patternKey: 'decimalNumber' },
            },
          },
        },

        truckInformation: {
          dangerousGoods: { required: false },
          loadingTypes: { required: true },
          truckPlateId: { required: false, patternKey: 'vehicleId' },
          truckPlateIdCountryOfOrigin: { required: false },
          trailerPlateId: { required: false, patternKey: 'vehicleId' },
          trailerPlateIdCountryOfOrigin: { required: false },
          truckSize: { required: true },
          emissionStage: { required: false },
        },

        contactData: {
          carrierEmail: { required: false, patternKey: 'email' },
          carrierName: { required: true },
          carrierExtId: { required: true },
          carrierPhone: { required: false, patternKey: 'phoneGeneric' },
          rbTransportPlannerEmail: { required: false, patternKey: 'email' },
          rbTransportPlannerPhone: { required: false, patternKey: 'phoneGeneric' },
        },

        driverInformation: {
          firstName: { required: false, patternKey: 'humanName' },
          lastName: { required: false, patternKey: 'humanName' },
          loanerPhoneId: { required: false, patternKey: 'phoneGeneric' },
          permitNumber: { required: false },
          permitType: { required: false },
          phoneNumber: { required: false, patternKey: 'phoneGeneric' },
          frequentDriverId: { required: false, patternKey: 'onlyNumber' },
        },
      },

      registerUli: {
        truckInformation: {
          loadingTypes: { required: true },
          truckPlateId: { required: true, patternKey: 'vehicleId' },
          trailerPlateId: { required: true, patternKey: 'vehicleId' },
          truckPlateIdCountryOfOrigin: { required: true },
          trailerPlateIdCountryOfOrigin: { required: true },
          emissionStage: { required: false },
        },

        driverInformation: {
          firstName: { required: true },
          lastName: { required: true },
          phoneNumber: { required: true, patternKey: 'phoneGeneric' },
          permitNumber: { required: false },
          permitType: { required: false },
          frequentDriverId: { required: false },
          loanerPhoneId: { required: false },
          parkingSpaceId: { required: false },
          remainingDrivingTime: { required: false },
          nextBreakLength: { required: false },
        },
      },

      createHub: {
        hubInfo: {
          name: { required: true },
          country: { required: true },
          timezone: { required: true },
          ssccId: { required: true, patternKey: 'ssccId' },
          nextActionApp: { required: true },
          coordinatorEmail: { required: false, patternKey: 'email' },
          coordinatorPhone: { required: false, patternKey: 'phoneGeneric' },
          mainGatePhone: { required: true, patternKey: 'phoneGeneric' },
          registrationDuration: { required: false, patternKey: 'onlyNumber' },
          securityOverdueMin: { required: false, patternKey: 'onlyNumber' },
          automaticUliCleaningDaysBefore: { required: false, patternKey: 'onlyNumber' },
          automaticUliCleaningDaysAfter: { required: false, patternKey: 'onlyNumber' },
          automaticUliCleaningHours: { required: false, patternKey: 'onlyNumber' },
        },
      },

      createCompartment: {
        generalInfo: {
          name: { required: true },
          ssccId: { required: true, patternKey: 'compartmentSsccId' },
          compartmentAddresses: { required: true },
          yardTime1: { required: true, patternKey: 'onlyNumber' },
          yardTime2: { required: true, patternKey: 'onlyNumber' },
          onTime: { required: true, patternKey: 'onlyNumber' },
        },
      },
    },
  },

  CN: {
    featureFlags: {
      showInspectionRedirectLink: false,
    },
    pages: {
      createUli: {
        uliInformation: {
          loadNumber: { required: true, shouldBeUnique: true },
          pickupPartyAddress: { required: true, disabled: false },
          deliveryPartyAddress: { required: true, disabled: false },
          dangerousGoods: { required: false },
          scheduledRegistrationTime: { required: true },
          type: { required: true },
          numberOfHandlingUnits: { required: true, patternKey: 'onlyNumber' },
          documentNumbers: { required: false },
          weightGross: { required: false, patternKey: 'onlyNumber' },
          loadingMeters: { required: false, patternKey: 'decimalNumber' },
        },

        multiStopInformation: {
          loadNumber: { required: true, shouldBeUnique: true },
          transportOrders: {
            isArray: true,
            elementRules: {
              activityType: { required: true },
              transportOrderNumber: { required: true },
              pickupPartyAddress: { required: true, disabled: false },
              deliveryPartyAddress: { required: true, disabled: false },
              dangerousGoods: { required: false },
              scheduledDepartureTime: { required: true },
              scheduledArrivalTime: { required: true },
              numberOfHandlingUnits: { required: true, patternKey: 'onlyNumber' },
              documentNumbers: { required: false },
              weightGross: { required: false, patternKey: 'onlyNumber' },
              loadingMeters: { required: false, patternKey: 'decimalNumber' },
            },
          },
        },

        truckInformation: {
          dangerousGoods: { required: false },
          loadingTypes: { required: true },
          truckPlateId: { required: true, patternKey: 'vehicleId' },
          truckPlateIdCountryOfOrigin: { required: false },
          trailerPlateId: { required: false, patternKey: 'vehicleId' },
          trailerPlateIdCountryOfOrigin: { required: false },
          truckSize: { required: true },
          emissionStage: { required: false },
        },

        contactData: {
          carrierEmail: { required: false, patternKey: 'email' },
          carrierName: { required: true },
          carrierExtId: { required: true },
          carrierPhone: { required: false, patternKey: 'phoneGeneric' },
          rbTransportPlannerEmail: { required: true, patternKey: 'email' },
          rbTransportPlannerPhone: { required: true, patternKey: 'phoneGeneric' },
        },

        driverInformation: {
          firstName: { required: true, patternKey: 'humanName' },
          lastName: { required: true, patternKey: 'humanName' },
          loanerPhoneId: { required: false, patternKey: 'phoneGeneric' },
          permitNumber: { required: true },
          permitType: { required: true },
          phoneNumber: { required: false, patternKey: 'phoneGeneric' },
          frequentDriverId: { required: false, patternKey: 'onlyNumber' },
        },
      },

      registerUli: {
        truckInformation: {
          loadingTypes: { required: true },
          truckPlateId: { required: true, patternKey: 'vehicleId' },
          trailerPlateId: { required: false, patternKey: 'vehicleId' },
          truckPlateIdCountryOfOrigin: { required: false },
          trailerPlateIdCountryOfOrigin: { required: false },
          emissionStage: { required: false },
        },

        driverInformation: {
          firstName: { required: true, patternKey: 'humanName' },
          lastName: { required: true, patternKey: 'humanName' },
          phoneNumber: { required: false },
          permitNumber: { required: false },
          permitType: { required: false },
          frequentDriverId: { required: false },
          loanerPhoneId: { required: false },
          parkingSpaceId: { required: false },
          remainingDrivingTime: { required: false },
          nextBreakLength: { required: false },
        },
      },

      createHub: {
        hubInfo: {
          name: { required: true },
          country: { required: true },
          timezone: { required: true },
          ssccId: { required: true, patternKey: 'ssccId' },
          nextActionApp: { required: true },
          coordinatorEmail: { required: false, patternKey: 'email' },
          coordinatorPhone: { required: false, patternKey: 'phoneGeneric' },
          mainGatePhone: { required: true, patternKey: 'phoneGeneric' },
          registrationDuration: { required: false, patternKey: 'onlyNumber' },
          securityOverdueMin: { required: false, patternKey: 'onlyNumber' },
          automaticUliCleaningDaysBefore: { required: false, patternKey: 'onlyNumber' },
          automaticUliCleaningDaysAfter: { required: false, patternKey: 'onlyNumber' },
          automaticUliCleaningHours: { required: false, patternKey: 'onlyNumber' },
        },
      },

      createCompartment: {
        generalInfo: {
          name: { required: true },
          ssccId: { required: true, patternKey: 'compartmentSsccId' },
          compartmentAddresses: { required: true },
          yardTime1: { required: true, patternKey: 'onlyNumber' },
          yardTime2: { required: true, patternKey: 'onlyNumber' },
          onTime: { required: true, patternKey: 'onlyNumber' },
        },
      },
    },
  },
};
